<template>
  <div>
    <div class="title">Мой профиль</div>
    <div class="divider"></div>
    <div class="user-profile__content">
      <div class="user-profile__form container px-0 grid-list-lg">
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Имя и Фамилия:</div>
          </div>
          <div class="flex xs6 sm4 form-fields">
            <input
              v-model="model.first_name"
              readonly
              type="text"
              class="form-input"
              placeholder="Введите имя"
            />
          </div>
          <div class="flex xs6 sm4 form-fields">
            <input
              v-model="model.last_name"
              readonly
              type="text"
              class="form-input"
              placeholder="Введите фамилию"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Город:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              readonly
              type="text"
              class="form-input"
              placeholder="Введите Город"
              v-model="model.city"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Телефон</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              readonly
              type="text"
              class="form-input"
              placeholder="Введите телефон"
              v-mask="'+7 (###) ###-##-##'"
              v-model="model.mobile_number"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">E-mail:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              readonly
              type="email"
              class="form-input"
              placeholder="Введите E-mail"
              v-model="model.email"
            />
          </div>
        </div>
        <!-- <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Имя и Фамилия:</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs6">
              <input
                :readonly="isRegistred"
                v-model="model.name"
                type="text"
                class="form-input"
                placeholder="Введите имя"
              />
            </div>
            <div class="flex xs6">
              <input
                :readonly="isRegistred"
                v-model="model.surname"
                type="text"
                class="form-input"
                placeholder="Введите фамилию"
              />
            </div>
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Nickname:</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs12">
              <input
                type="text"
                class="form-input"
                placeholder="Никнейм в игре"
                readonly="readonly"
                :value="model.nickname"
              />
            </div>
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Телефон</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs1 d-flex align-center">
              <div class="form-input-plefix">+7</div>
            </div>
            <div class="flex xs5">
              <input
                ref="phone_code"
                :readonly="isRegistred"
                type="text"
                class="form-input"
                v-mask="'###'"
                v-model="model.phone_code"
                placeholder="Код (555)"
              />
            </div>
            <div class="flex xs6">
              <input
                ref="phone_number"
                :readonly="isRegistred"
                type="text"
                class="form-input"
                v-mask="'###-##-##'"
                v-model="model.phone_number"
                placeholder="Номер (555-55-55)"
              />
            </div>
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm4 sm8 form-fields">
            <FormSwitch
              :readonly="isRegistred"
              v-model="confirmAge"
              label="Подтверждаю, что мне исполнилось 18 лет"
            />
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">VK:</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs12">
              <input
                type="text"
                class="form-input"
                placeholder="Ссылка на страницу в ВК"
                :readonly="isRegistred"
                v-model="model.vk_id"
              />
            </div>
          </div>
        </div>
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">ID в Discord:</div>
          </div>
          <div class="flex xs12 sm8 form-fields pt-0 layout row wrap">
            <div class="flex xs12">
              <input
                type="text"
                class="form-input"
                placeholder="Ваш ID в Discord, например: Nickname#1234"
                :readonly="isRegistred"
                v-model="model.discord_id"
              />
            </div>
            <div class="flex xs12 ma-0 layout row align-start">
              <FormSwitch :readonly="isRegistred" v-model="confirmPolicy">
                <template #label>
                  <div class="form-text">
                    <p>
                      Я даю свое добровольное согласие на предоставление и
                      дальнейшую обработку моих персональных данных ООО «Ред
                      Булл (Рус)» в соответствии с целями, перечисленными в
                      <a
                        target="_blank"
                        @click.stop=""
                        href="https://policies.redbull.com/policies/RedBull.com_Russia/201907010152/ru/privacy.html"
                      >
                        Положении о конфиденциальности компании Red Bull.
                      </a>
                    </p>
                  </div>
                </template>
              </FormSwitch>
            </div>
          </div>

          <div
            v-if="!isRegistred"
            class="flex xs12 form-row layout row align-center justify-center"
          >
            <app-btn
              :disabled="!valid"
              :loading="processing"
              @click="submit"
              round
              color="orange-grad"
              class="px-4"
              >Зарегистрироваться</app-btn
            >
          </div>
        </div> -->
      </div>
    </div>
    <template v-if="record">
      <div class="title mt-5">Моё видео</div>
      <div class="divider"></div>
      <Player
        class="user-profile__record"
        :video="record.base_video.video"
        :audio="record.audio_path"
      />
    </template>
  </div>
</template>

<script>
import { VueMaskDirective } from "v-mask";
import { asyncModal } from "@/components/ui/modal/";
import authSerivce from "@/services/auth";
import showAlert from "@/services/common/showAlert";
import clone from "lodash/clone";
import Player from "@/components/videos/Player";

const ContestProfile = {
  name: "ContestProfile",
  directives: { mask: VueMaskDirective },
  components: {
    Player
  },
  props: {
    user: {
      type: Object,
      required: false
    },
    record: {
      type: Object,
      required: false
    },
    isRegistred: Boolean
  },

  data() {
    return {
      processing: false,
      model: clone(this.user) || {}
    };
  },

  methods: {
    async submit() {
      if (!this.valid || this.processing) return;
      this.processing = true;

      let data = await authSerivce.register(this.toSend);

      if (data.success) {
        await this.$store.dispatch("auth/getProfile");
        this.$modals.close();
      }
      this.processing = false;

      this.$nextTick(() => {
        if (data.message) showAlert(data.message, 2500);
      });
    }
  }
};

export default ContestProfile;

export function openModal(user = null, record = null, isRegistred = true) {
  return asyncModal({
    name: "user-profile",
    component: ContestProfile,
    props: {
      user,
      record,
      isRegistred
    }
  });
}
</script>

<style lang="scss">
.user-profile {
  &__record {
    overflow: hidden;
    border-radius: 6px;
    box-shadow: 0px 8px 15px 0 #000a25;

    /* margin: 30px 0;
    @include breakpoint("xs-only") {
      margin: 20px 0;
    } */
  }
}
</style>
